import React from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Store from './Common/Store.js';

class HtmlEditor extends React.Component
{
    render()
    {
        let content = this.props.content;
        return (
            <div>
                <CKEditor
                    editor={ ClassicEditor }
                    data={content}
                    config={{ link: {defaultProtocol: 'http://', addTargetToExternalLinks: true}, removePlugins: ['Table', 'BlockQuote', 'ImageUpload', 'Indent', 'MediaEmbed'] }}
                    onInit={ editor => {
                        // You can store the "editor" and use when it is needed.
                        // console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const linkCommand = editor.commands.get( 'link' );
                        const model = editor.model;
                        const selection = model.document.selection;
                        const linkHref = selection.getAttribute( 'linkHref' );
                        if(linkHref !== undefined){
                            if (linkHref.indexOf("http://") == 0 || linkHref.indexOf("https://") == 0) {
                                console.log("The link has http or https.");
                            }else{
                                alert("Please ensure that you have included the full URL. It should begin with https:// or similar.")
                                return false
                            }
                        }

                        const data = editor.getData();
                        // console.log("data:", data);
                        if (this.props.section_id === "0") {
                            Store.updateStore('summary', data);
                        } else {
                            let sections = JSON.parse(JSON.stringify(Store.getStoreData('sections')));
                            sections.forEach((section) => {
                                if (parseInt(this.props.section_id) === parseInt(section.id)) {
                                    // console.log("store section content:", section.content);
                                    section.content = data;
                                }
                            })
                            Store.updateStore('sections', sections);
                            // console.log("summary", Store.getStoreData('summary'));
                            // console.log("sections", Store.getStoreData('sections'));
                        }
                        // console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => {
                        // console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        // console.log( 'Focus.', editor );
                    } }
                />
            </div>
        );
    }
}
export default HtmlEditor;